export default "__VITE_ASSET__DpPaL413__"